import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/loading.svg'


const _hoisted_1 = {
  key: 0,
  class: "form-header"
}
const _hoisted_2 = { class: "title" }
const _hoisted_3 = {
  key: 0,
  class: "errors"
}
const _hoisted_4 = {
  key: 1,
  class: "errors"
}
const _hoisted_5 = { class: "form-content" }
const _hoisted_6 = { class: "form-fields" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h3", null, "Informations complémentaires", -1)
const _hoisted_8 = { class: "form-fields" }
const _hoisted_9 = { class: "form-footer" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Soumettre ")
const _hoisted_12 = {
  key: 1,
  class: "spinner"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "spinner-icon",
  alt: "UNUCR"
}, null, -1)
const _hoisted_14 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FileField = _resolveComponent("FileField")!
  const _component_StaticField = _resolveComponent("StaticField")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.canSubmit ? _ctx.submit() : () => {}), ["prevent"])),
    class: "form"
  }, [
    (_ctx.title)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h2", _hoisted_2, _toDisplayString(_ctx.title), 1),
          (_ctx.errors && _ctx.errors.fields)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors.fields['sheets'], (error, index) => {
                  return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(error), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "header")
        ]))
      : _createCommentVNode("", true),
    (_ctx.errors && _ctx.errors.message)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("p", null, _toDisplayString(_ctx.errors.message), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (field, index) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: `form-field-${index}`
          }, [
            (field.type === 'slot')
              ? _renderSlot(_ctx.$slots, field.name, _mergeProps({ key: 0 }, field, {
                  state: field.getState()
                }))
              : (field.type === 'file')
                ? (_openBlock(), _createBlock(_component_FileField, {
                    key: 1,
                    class: "form-row",
                    config: field,
                    errors: _ctx.getFieldErrors(field.name)
                  }, null, 8, ["config", "errors"]))
                : (
                            field.type === 'static-img' ||
                            field.type === 'static-text' ||
                            field.type === 'static-link'
                        )
                  ? (_openBlock(), _createBlock(_component_StaticField, {
                      key: 2,
                      class: "form-row",
                      config: field
                    }, null, 8, ["config"]))
                  : (_openBlock(), _createBlock(_component_Field, {
                      key: 3,
                      class: "form-row",
                      config: field,
                      errors: _ctx.getFieldErrors(field.name),
                      disabled: _ctx.disabled
                    }, null, 8, ["config", "errors", "disabled"]))
          ], 64))
        }), 128)),
        _renderSlot(_ctx.$slots, "content")
      ]),
      (_ctx.showComplementaryFields)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.complementaryFields, (field, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, {
                  key: `form-field-${index}`
                }, [
                  (field.type === 'file')
                    ? (_openBlock(), _createBlock(_component_FileField, {
                        key: 0,
                        class: "form-row",
                        config: field,
                        errors: _ctx.getFieldErrors(field.name)
                      }, null, 8, ["config", "errors"]))
                    : (
                                field.type === 'static-img' ||
                                field.type === 'static-text' ||
                                field.type === 'static-link'
                            )
                      ? (_openBlock(), _createBlock(_component_StaticField, {
                          key: 1,
                          config: field
                        }, null, 8, ["config"]))
                      : (_openBlock(), _createBlock(_component_Field, {
                          key: 2,
                          class: "form-row",
                          config: field,
                          errors: _ctx.getFieldErrors(field.name)
                        }, null, 8, ["config", "errors"]))
                ], 64))
              }), 128))
            ])
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.complementaryFields)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "btn btn-light",
            type: "button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onToggleComplementaryFieldsVisibility && _ctx.onToggleComplementaryFieldsVisibility(...args)))
          }, _toDisplayString(_ctx.showComplementaryFields
                        ? "Cacher les informations complémentaires"
                        : "Saisir plus d'informations"), 1))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_9, [
      (!_ctx.disabled && _ctx.driverDelete !== undefined)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "btn btn-light danger",
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.driverDelete && _ctx.driverDelete(...args)), ["prevent"])),
            type: "button"
          }, " Supprimer "))
        : _createCommentVNode("", true),
      (!_ctx.disabled && _ctx.driver?.submit !== undefined)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            type: "submit",
            class: "btn btn-primary",
            disabled: !_ctx.canSubmit
          }, [
            (!_ctx.submitLoading)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_11
                ], 64))
              : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
          ], 8, _hoisted_10))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "footer")
    ])
  ], 32))
}